import { createSvgComponent } from "../../icon/createSvgComponent";
import Filter from "@core/__generated__/icon/figma/filter.svg";
export default createSvgComponent(Filter);